<template>
  <JyPagebody :activatedLoad="reloadData" class="news-list-container">
    <TemplateList :title="ischeck ? '内容审核列表' : '内容列表'" :activatedLoad="reloadData" :hasFooter="true">
      <template v-slot:searchBar>
        <div class="mb-1 ml-md-2">
          <JyButton v-if="hasPermiss('news.info.add')" type="primary" @click="doEdit(null)" is-outline>添加</JyButton>
        </div>
        <div class="mb-1 ml-md-2">
          <el-select v-loading="loading.newscateList" v-model="searchData.cateid" size="small" placeholder="查询：类别" clearable filterable style="width:10rem">
            <template v-for="item in newscateList">
              <el-option v-if="hasCate(item.id)" :label="item.name" :value="item.id" :key="item.id" :disabled="item.issingle">
                {{ !item.parentid ? '' : (space2 +'- ') }}{{ item.name }}
              </el-option>
            </template>
          </el-select>
        </div>
        <div class="mb-1 ml-md-2">
          <el-select v-loading="statusLoading.checkStatus" v-model.number="searchData.status" size="small" placeholder="查询：状态" clearable filterable style="width:10rem">
            <template v-for="(v, k) in checkStatus">
              <el-option :key="k" :label="v" :value="parseInt(k)">{{ v }}</el-option>
            </template>
          </el-select>
        </div>
        <div class="mb-1 ml-md-2">
          <el-input v-model="searchData.title" size="small" placeholder="查询：标题" style="width:10rem" clearable></el-input>
        </div>
        <JyButton type="primary" icon="search" class="mb-1 ml-md-1" @click="doSearch">查询</JyButton>
        <!-- <JyButton type="warning" icon="question" class="mb-1 ml-md-1" @click="doHelp('stu')">帮助</JyButton> -->
      </template>
      <el-form slot="card" v-loading="loadedData" element-loading-text="努力加载中..." size="small" class="row col-gutters-10 align-items-stretch view-form">
        <div v-if="!list || !list.length" class="col">
          <div class="card mb-3 box-shadow">
            <div class="card-body">
              <i class="fa fa-exclamation-circle text-danger">&nbsp;&nbsp;</i>未查询到数据...
            </div>
          </div>
        </div>
        <div v-for="(item, index) in list" :key="item.id" class="col-6 col-sm-4 col-md-3 mb-3">
          <div class="card h-100 box-shadow" @mouseenter="enterCard(1, $event)" @mouseleave="enterCard(0, $event)">
            <div class="card-header p-2">
              <h5 class="card-title d-flex mb-1 line-h-15 clearfix" style="height:50px;">
                <div class="mr-2 text-muted flex-shrink-0">#{{ accum + index + 1 }} </div>
                <a class="flex-grow-1 ellipsis-2" href="javascript:;" @click="doView(item)" title="查看内容详细信息">{{ item.title }}</a>
              </h5>
            </div>
            <div class="card-body p-2">
              <el-tabs value="home">
                <el-tab-pane name="home" label="内容信息">
                  <el-row type="flex" class="flex-wrap">
                    <form-item label-width="80px" fill="4">
                      <span slot="label" class="fonts85">所属分类</span>
                      <span>
                        {{ item.catename }}
                      </span>
                    </form-item>
                    <form-item label-width="80px" fill="4">
                      <span slot="label" class="fonts85">选项</span>
                      <span>
                        <JyBadge v-show="item.istop" :type="item.istop ? 'primary' : ''" class="mr-2">{{ item.istop ? '置顶' : '' }}</JyBadge>
                        <JyBadge v-show="item.isfocus" :type="item.isfocus ? 'success' : ''" class="mr-2">{{ item.isfocus ? '图片新闻' : '' }}</JyBadge>
                        <JyBadge v-show="item.needip" type="success" class="mr-2">仅授权IP访问</JyBadge>
                        <JyBadge v-show="item.othertop" type="success">置顶其他</JyBadge>
                      </span>
                    </form-item>
                    <form-item label-width="80px" fill="4">
                      <span slot="label" class="fonts85">点击数</span>
                      <span>{{ item.hits }}</span>
                    </form-item>
                    <form-item label-width="80px" fill="4">
                      <span slot="label" class="fonts85">链接</span>
                      <el-popover @show="onOpenLink(item)">
                        <a slot="reference" href="javascript:;">查看</a>
                        <div>
                          <el-input :value="newsUrl(item)" @focus="onInputFocus" readonly>
                            <el-button slot="append" type="danger" icon="copy" @click="doCopy" class="copy-btn">复制链接</el-button>
                          </el-input>
                        </div>
                      </el-popover>
                    </form-item>
                    <form-item label-width="80px" fill="4">
                      <span slot="label" class="fonts85">状态</span>
                      <JyBadge :type="checkStatusType(item)">{{ checkStatus[item.status] || item.status }}</JyBadge>
                    </form-item>
                    <form-item label-width="80px" fill="4">
                      <span slot="label" class="fonts85">审稿人</span>
                      <span>{{ item.sgr }}</span>
                    </form-item>
                    <form-item label-width="80px" fill="4">
                      <span slot="label" class="fonts85">发布人</span>
                      <span>{{ item.createusername || item.createuser }}</span>
                    </form-item>
                    <form-item label-width="80px" fill="4">
                      <span slot="label" class="fonts85">发布时间</span>
                      <span>{{ item.createtime}}</span>
                    </form-item>
                  </el-row>
                </el-tab-pane>
              </el-tabs>
            </div>
            <div class="card-footer p-2">
              <div class="d-flex align-items-center">
                <div>
                  <JyButton v-if="hasPermiss('news.needcheck1.check') && !item.status" type="info" size="sm" class="mr-2" @click="doChangeSelect('check1', item)" icon="check">初审</JyButton>
                  <JyButton v-if="hasPermiss('news.check.check') && item.status != 2" type="info" size="sm" class="mr-2" @click="doChangeSelect('check', item)" icon="check">审核</JyButton>
                </div>
                <div class="ml-auto">
                  <JyButton v-if="hasPermiss('news.info.edit')" type="success" size="sm" class="mr-2" @click="doEdit(item)" icon="edit">编辑</JyButton>
                  <JyButton v-if="hasPermiss('news.info.del')" type="danger" size="sm" @click="doChangeSelect('del', item)" icon="times">删除</JyButton>
                </div>
              </div>
            </div>
          </div>
        </div>
      </el-form>
      <el-table slot="grid" border stripe v-loading="loadedData" element-loading-text="努力加载中..." :data="list" height="100%"
        row-key="id"
        @selection-change="handleSelection"
      >
        <!-- <el-table-column type="index" :index="indexMethod"></el-table-column> -->
        <el-table-column
          type="selection"
          fixed
          width="35" />
        <el-table-column
          fixed
          width="55">
          <template v-slot:header>
            <el-popover
              placement="top"
              append-to-body
              trigger="click">
              <div class="d-flex flex-column">
                <JyButton v-if="hasPermiss('news.check.check')" type="info" is-block is-outline :is-loading="delLoading" class="mb-2" @click="doChangeSelect('check')">审核</JyButton>
                <JyButton v-if="hasPermiss('news.needcheck1.check')" type="info" is-block is-outline :is-loading="delLoading" class="mb-2" @click="doChangeSelect('check1')">初审</JyButton>
                <JyButton v-if="hasPermiss('news.info.del')" type="danger" is-block is-outline :is-loading="delLoading" @click="doChangeSelect('del')">删除</JyButton>
              </div>
              <a href="javascript:;" slot="reference" class="d-block pr-1 text-nowrap text-danger">批量<i class="fa fa-caret-down fa-fw"></i></a>
            </el-popover>
          </template>
          <template v-slot="{$index}">
            {{ indexMethod($index) }}
          </template>
        </el-table-column>
        <jy-table-column label="标题">
          <template v-slot="{row}">
            <a href="javascript:;" @click="doView(row)">{{ row.title }}</a>
          </template>
        </jy-table-column>
        <jy-table-column prop="allcate" label="类别"></jy-table-column>
        <jy-table-column prop="createtime" label="选项">
          <template v-slot="{row}">
            <JyBadge v-show="row.istop" type="success">置顶</JyBadge>
            <JyBadge v-show="row.isfocus" type="success">图片新闻</JyBadge>
            <JyBadge v-show="row.needip" type="success">仅授权IP访问</JyBadge>
            <JyBadge v-show="row.othertop" type="success">置顶其他</JyBadge>
          </template>
        </jy-table-column>
        <jy-table-column prop="hits" label="点击数"></jy-table-column>
        <jy-table-column prop="createtime" label="链接">
          <template v-slot="{row}">
            <el-popover @show="onOpenLink(row)">
              <a slot="reference" href="javascript:;">查看</a>
              <div>
                <el-input :value="newsUrl(row)" @focus="onInputFocus" readonly>
                  <el-button slot="append" type="danger" icon="copy" @click="doCopy" class="copy-btn">复制链接</el-button>
                </el-input>
              </div>
            </el-popover>
          </template>
        </jy-table-column>
        <jy-table-column prop="status" label="状态">
          <template v-slot="{row}">
            <JyBadge :type="checkStatusType(row)">{{ checkStatus[row.status] || row.status }}</JyBadge>
          </template>
        </jy-table-column>
        <jy-table-column prop="sgr" label="审稿人"></jy-table-column>
        <jy-table-column prop="createusername" label="发布人"></jy-table-column>
        <jy-table-column prop="createtime" label="发布时间"></jy-table-column>
        <el-table-column label="操作" width="60" fixed="right">
          <template v-slot="{row}">
            <el-popover
              ref="popover-edit"
              placement="bottom"
              append-to-body
              trigger="click">
              <div class="d-flex flex-column">
                <JyButton v-if="hasPermiss('news.info.edit')" type="primary" size="sm" is-block class="mb-2" @click="doEdit(row)">编辑</JyButton>
                <JyButton v-if="hasPermiss('news.check.check') && row.status != 2" type="info" size="sm" is-block class="mb-2" @click="doChangeSelect('check', row)">审核</JyButton>
                <JyButton v-if="hasPermiss('news.needcheck1.check') && !row.status" type="info" size="sm" is-block class="mb-2" @click="doChangeSelect('check1', row)">初审</JyButton>
                <JyButton v-if="hasPermiss('news.info.del')" type="danger" size="sm" is-block is-outline @click="doChangeSelect('del', row)">删除</JyButton>
              </div>
              <a href="javascript:;" slot="reference" class="d-block text-nowrap">操作<i class="fa fa-caret-down fa-fw"></i></a>
            </el-popover>
          </template>
        </el-table-column>
        <!-- <el-table-column :expand="true" label="展开列">
          <template v-slot="{row}">
            <div class="row expand-box">
              <div class="col">
                <label class="float-left text-right">帮助内容</label><div class="d-inline-block" v-html="row.content"></div>
              </div>
            </div>
          </template>
        </el-table-column> -->
      </el-table>
    </TemplateList>
    <el-pagination
      slot="footer"
      :small="isSm"
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-sizes="[10, 20, 30, 50, 100, 200]"
      :page-size="pageSize"
      :layout="pageLayout"
      :total="totalRow">
    </el-pagination>
    <NewsView :newsid="editData.id" ref="newsView"></NewsView>
    <!-- 剪贴板 -->
    <a href="javascript:;" ref="copyBtn" :data-clipboard-text="copyUrl" style="display:none;">查看</a>
  </JyPagebody>
</template>

<script>
import { mapGetters } from 'vuex';
import * as types from '@/store/mutation-types';
import tools from 'jyutils/tools';
import list from '../mixin/list';
import Clipboard from 'clipboard';
import TemplateList from '../template-list.vue';
import NewsView from './news-view.vue';
import { checkStatusType } from '../mixin/global';
export default {
  components: {
    TemplateList, NewsView
  },
  mixins: [tools, list],
  props: {
    ischeck: {
      type: Boolean,
      defautl: false
    }
  },
  data() {
    return {
      pageSize: 10,
      searchData: {cateid:'', title:'', status: null},
      clipboard: null,
      copyUrl: null,
      delLoading: false
    }
  },
  computed: {
    ...mapGetters({
      checkStatus: [types.STATUS.checkStatus],
      newscateList: [types.BASE_LOAD.newscateList],
      reloadNews: [types.OTHER.reloadNews],
      loading: [types.BASE_LOAD.baseLoading],
      statusLoading: [types.STATUS.statusLoading]
    }),
    listUrl() {
      return 'sys/news';
    },
    queryData() {
      return Object.assign({}, {pageCurrent: this.currentPage, pageSize: this.pageSize, issingle: false, forcheck: this.ischeck}, this.searchData);
    }
  },
  watch: {
    reloadNews() {
      this.loadList();
    },
    ischeck() {
      this.doSearch();
    }
  },
  beforeDestroy () {
    this.clipboard && this.clipboard.destroy();
    this.clipboard = null;
  },
  methods: {
    reloadData() {
      if (!this.list || !this.list.length)
        this.loadList();
      if (!this.newscateList || !this.newscateList.length) {
        this.$store.dispatch(types.BASE_LOAD.newscateList);
      }
      if (!this.checkStatus || !Object.keys(this.checkStatus).length) {
        this.$store.dispatch(types.STATUS.checkStatus);
      }
      this.clipboard && this.clipboard.destroy();
      this.clipboard = new Clipboard(this.$refs.copyBtn);
      this.clipboard.on('success', () => {
        this.$message.success('复制成功！');
      });
      this.clipboard.on('error', () => {
        // 释放内存
        this.clipboard.destroy();
        this.$message.error('复制失败，你的浏览器不支持自动复制！');
      });
    },
    doEdit(data) {
      this.editData = data || {};
      if (this.editData.id) {
        this.$router.push({name: 'news-edit', params: {id: this.editData.id }});
      } else {
        this.$router.push({name: 'news-add'});
      }
    },
    checkStatusType(data) {
      return checkStatusType(data.status);
    },
    doSave() {
      this.loadList();
    },
    doView(data) {
      this.editData = data;
      this.$refs.newsView.show(true);
    },
    addRoot() {
      this.doEdit(null);
    },
    newsUrl(item) {
      return `${this.BASEPATH}/detail/${item.id}`;
    },
    onInputFocus(e) {
      e.target.select();
    },
    onOpenLink(item) {
      this.copyUrl = this.newsUrl(item);
    },
    doCopy() {
      // 触发剪贴板点击
      this.$refs.copyBtn.click();
    },
    doDel(data) {
      this.msgbox('此操作将永久删除该记录, 是否继续?', () => {
        this.doPost({
          url: 'sys/news/del/'+ data.id,
          okcb: () => {
            this.loadList();
            this.$message.success('删除成功!');
          }
        });
      });
    },
    doChangeSelect(t, item) {
      if (!item && !this.selectedId.length) {
        this.$message.warning('未选中任何记录！');
        return;
      }
      let txt = '', _t = item ? '该' : '选中';
      switch(t) {
        case 'submit':
          txt = `提交审核`;
          break;
        case 'back':
          txt = `退回`;
          break;
        case 'check':
          txt = `通过审核`;
        break;
        case 'check1':
          txt = `通过通审`;
        break;
        case 'cancel':
          txt = `取消`;
        break;
        case 'del':
          txt = `删除`;
        break;
      }

      let msg =`确定要${txt}${_t}记录吗？`
      if (item) {
        this.selectedId = [item.id];
      }
      this.msgbox(msg, () => {
        if (t == 'del') {
          if (item) {
            this.$set(item, 'delLoading', true);
          } else {
            this.delLoading = true;
          }
        } else {
          if (item) {
            this.$set(item, 'changeLoading', true);
          } else {
            this.changeLoading = true;
          }
        }

        this.doPost({
          url: 'sys/news/'+ t,
          data: {ids: this.selectedId.join(',')},
          okcb: (json, msg) => {
            this.loadList();
            if (msg) {
              this.$message(msg);
            }
          },
          cb: () => {
            if (t == 'del') {
              this.delLoading = false;
              if (item) {
                item.delLoading = false;
              }
            } else {
              this.changeLoading = false;
              if (item) {
                item.changeLoading = false;
              }
            }
          }
        });
      });

    },
    handleSelection(selection) {
      this.selectedId = selection.map(d => {
        return d.id;
      });
    },
  }
}
</script>
